import { MIN_INJURIES_AC_NO } from "./constants";

export const normalizePrototypeGroups = (source, listKey) => {
  if (Array.isArray(source)) {
    return [
      {
        key: "default",
        prototype_set_id: "",
        english_set_name: "",
        danish_set_name: "",
        [listKey]: source,
      },
    ];
  }

  if (!source || typeof source !== "object") {
    return [];
  }

  return Object.entries(source).map(([key, value]) => ({
    key,
    prototype_set_id: value?.prototype_set_id ?? key,
    english_set_name: value?.english_set_name ?? "",
    danish_set_name: value?.danish_set_name ?? "",
    [listKey]: Array.isArray(value?.[listKey]) ? value[listKey] : [],
  }));
};

export const dedupeBy = (items, getKey) => {
  const seen = new Set();
  const rows = [];

  items.forEach((item) => {
    const key = getKey(item);
    if (!key || seen.has(key)) return;
    seen.add(key);
    rows.push(item);
  });

  return rows;
};

export const hasValidEmployeeValue = (employee) => {
  if (employee === null || employee === undefined) return false;
  const normalized = String(employee).trim();
  if (!normalized) return false;
  return normalized.toLowerCase() !== "null";
};

export const normalizeIncidentType = (value) => {
  const normalized = String(value ?? "")
    .trim()
    .toLowerCase();
  return normalized === "null" ? "" : normalized;
};

export const getIncidentTypeValue = (record) =>
  normalizeIncidentType(
    record?.real_incident_type || record?.read_incident_type,
  );

export const isTruthyFlag = (value) => {
  if (value === true) return true;
  if (value === false || value === null || value === undefined) return false;

  const normalized = String(value).trim().toLowerCase();
  return normalized === "1" || normalized === "true";
};

export const buildFallbackCardsFromRecords = (records = []) =>
  dedupeBy(
    (Array.isArray(records) ? records : [])
      .map((record) => String(record?.action_card_number ?? "").trim())
      .filter(Boolean)
      .map((acNo) => ({
        ac_no: acNo,
        english_short_name: acNo,
      })),
    (card) => String(card?.ac_no ?? ""),
  );

export const getRiskRecordKey = (record) =>
  String(
    record?.id ??
      `${record?.utc_tid_skannet ?? ""}-${record?.action_card_number ?? ""}-${
        record?.user_id ?? ""
      }`,
  );

export const isMinInjuriesRecord = (record) =>
  String(record?.action_card_number ?? "").trim() === MIN_INJURIES_AC_NO;

export const isMinInjuriesCard = (card) =>
  String(card?.ac_no ?? card?.id ?? "").trim() === MIN_INJURIES_AC_NO;
